import { AbstractStruct } from '@pushly/models/lib/structs/abstract-struct'
import { Expose } from 'class-transformer'
import { NativeApnsSendIntegrationConfig } from '@pushly/models/lib/structs/send-integration-configurations/native-apns-send-integration-config'
import { NativeFcmSendIntegrationConfig } from '@pushly/models/lib/structs/send-integration-configurations/native-fcm-send-integration-config'

export class PlatformUserDomainRecord extends AbstractStruct {
    @Expose()
    public readonly id: number

    @Expose()
    public readonly name: string

    @Expose()
    public readonly display_name: string

    @Expose()
    public readonly status_id: string

    @Expose()
    public readonly account_id: number

    @Expose()
    public readonly account_name: string

    @Expose()
    public readonly account_flags: string[]

    @Expose()
    public readonly timezone: string

    @Expose()
    public readonly flags: string[]

    @Expose()
    public readonly default_icon_url: string

    @Expose()
    public readonly native_apns_configuration: NativeApnsSendIntegrationConfig

    @Expose()
    public readonly native_fcm_configuration: NativeFcmSendIntegrationConfig
}
